import React, { SVGProps } from 'react';
import svgSprite from '@assets/svg/_sprite.svg';
import svgSprite2 from '@assets/svg/_sprite2.svg';
import s from './SvgIcon.module.scss';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  name: string;
  className?: string;
  sprite?: 'default' | 'sprite2';
  /** Стандартные размеры иконок */
  size?: 'small' | 'medium' | 'large' | 'xlarge' | 'square' | number;
  /** Прямое указание ширины (приоритет над size) */
  width?: number | string;
  /** Прямое указание высоты (приоритет над size) */
  height?: number | string;
  fill?: 'none' | 'currentColor' | string;
}

const SvgIcon: React.FC<SvgIconProps> = ({
  name,
  size,
  sprite = 'default',
  width,
  height,
  className = '',
  fill = 'currentColor',
  style,
  ...props
}) => {
  const iconClasses = [s.icon, className].filter(Boolean).join(' ');

  const dataSize = width || height ? undefined : size;

  /** В `<symbol>` с `fill="currentColor"` часть движков берёт цвет из CSS `color`, а не из атрибута `fill` у `<svg>`. */
  const symbolTintColor =
    fill !== 'none' && fill !== 'currentColor' ? fill : undefined;
  const mergedStyle =
    symbolTintColor != null ? { color: symbolTintColor, ...style } : style;

  return (
    <svg
      className={iconClasses}
      data-size={dataSize}
      width={width}
      height={height}
      fill={fill}
      style={mergedStyle}
      {...props}
    >
      <use href={sprite === 'default' ? svgSprite + `#${name}` : svgSprite2 + `#${name}`} />
    </svg>
  );
};

export default SvgIcon;
